import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { FieldInitialSettings, FieldSchema, RawField } from '@FormModule';
import type { GenericField } from '@Types';
import { useForm } from '@FormModule';

const currentSchemaModels = ref<Set<GenericField>>(new Set());
const fieldsSchema = ref<FieldSchema[]>([]);
const formError = ref();

export default function () {
  const { getDetailsSchema } = useForm();
  const { t } = useI18n();

  const fieldsSettings: FieldInitialSettings = {
    primary: {
      edit: {
        label: 'name',
        value: 'value',
        options: [
          { name: t('common.yes'), value: true },
          { name: t('common.no'), value: false },
        ],
      },
    },
    phones: {
      model: [{ id: 1, contact: null, type: 'home', primary: false }],
      edit: {
        value: 'value',
        options: [
          { name: 'Mobile', value: 'mobile' },
          { name: 'Home', value: 'home' },
          { name: 'Work', value: 'work' },
          { name: 'Other', value: 'other' },
        ],
      },
      settings: {
        contactType: 'phone',
      },
    },
    emails: {
      model: [{ id: 1, contact: null, type: 'home', primary: false }],
      edit: {
        value: 'value',
        options: [
          { name: 'Home', value: 'home' },
          { name: 'Work', value: 'work' },
          { name: 'Other', value: 'other' },
        ],
      },
      settings: {
        contactType: 'email',
      },
    },
  };
  const rawFields: RawField[] = [
    {
      label: 'Primary',
      name: 'primary',
      required: false,
      type: 'radio',
      value: '',
    },
    {
      label: 'First Name',
      name: 'first_name',
      required: true,
      type: 'text',
      value: '',
    },
    {
      label: 'Last Name',
      name: 'last_name',
      required: false,
      type: 'text',
      value: '',
    },
    {
      label: 'Phones',
      name: 'phones',
      required: false,
      type: 'contact_type',
      value: '',
    },
    {
      label: ' Emails',
      name: 'emails',
      required: false,
      type: 'contact_type',
      value: '',
    },
  ];

  function setForm() {
    if (fieldsSchema.value.length) return;

    fieldsSchema.value = getDetailsSchema(rawFields, fieldsSettings);
  }

  function updateSchemaModels(sourceData: any) {
    setForm();

    fieldsSchema.value.forEach((field) => {
      const match = sourceData[field.name];

      switch (field.name) {
        case 'emails': {
          field.model = formatContacts(sourceData.emails);
          field.value = formatContacts(sourceData.emails);
          break;
        }
        case 'phones': {
          field.model = formatContacts(sourceData.phones);
          field.value = formatContacts(sourceData.phones);
          break;
        }
        default: {
          field.model = match;
          field.value = match;
        }
      }
    });
  }

  function formatContacts(contacts: any[]) {
    return contacts.map(({ email, phone, ...contactInfo }) => ({
      ...contactInfo,
      contact: email || phone,
    }));
  }

  function resetFieldSchema() {
    currentSchemaModels.value = new Set();
    fieldsSchema.value = [];
    formError.value = null;
  }

  return {
    currentSchemaModels,
    fieldsSchema,
    fieldsSettings,
    formError,
    rawFields,
    resetFieldSchema,
    setForm,
    updateSchemaModels,
  };
}
